import React, {Component} from 'react';
import compose from 'recompose/compose';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';
import _ from 'lodash';
import {getArrayIndex} from '../../../common/utils/array';
import {
	getUserList,
	changeCurrentPath,
	resetMainListState,
	resetConsigneeListStateNew,
	getJigyoshaList,
	setUserList,
	resetMasterUsers,
	fetchCsvMasterUser,
	getUserQrPdf,
	clearGetUserQrPdf
} from '../../../actions';

import Header from '../../../common/containers/header';
import Progress from '../../../common/containers/progress'
import SpNav from '../../../common/containers/sp_nav'
import Footer from '../../../common/containers/footer';

import ErrorDialog from '../../../common/components/dialog/error-dialog';
import ReloadModal from '../../../common/components/dialog/reload-dialog';
import LogoutModal from '../../../common/components/dialog/logout-dialog';

import MainButtons from '../../../common/components/main-buttons';

import MasterTable from '../../../common/components/table/master-table';
import AlertDialog from '../../../common/components/dialog/alert-dialog';
import PdfViewer from "../../../common/components/viewer/pdf-viewer";

const styles = theme => ({
	buttonHide: {
		position: 'absolute',
		top: 0,
		backgroundColor: '#FFFFFF',
		height: '100%',
		zIndex: 6,
	},
	buttonHideLeft: {
		left: -20,
		width: 20
	},
	buttonHideRight: {
		right: -100,
		width: 100
	},
	cautionText: {
		marginTop: -20,
		color: '#f90c0c'
	}
});

let columns = [
	{
		name: 'JigyoushaCD_Obj',
		title: '事業者コード',
		width: 300,
		maxLength: 10,
		disabled: true,
		newDisabled: false,
		validations: ["required"]
	},
	{
		name: 'UserID',
		title: 'ユーザーID',
		width: 150,
		maxLength: 20,
		defaultValue: '',
		disabled: true,
		newDisabled: false,
		validations: ["unique", "new_required", "numLetter"],
		uniqueSubKey: "JigyoushaCD_Obj"
	},
	{name: 'UserName', title: 'ユーザー名', width: 350, maxLength: 40, defaultValue: '', validations: ["required"]},
	{name: 'Furigana', title: 'フリガナ', width: 350, maxLength: 40, defaultValue: '', validations: ["required"]},
	{
		name: 'UserPassword',
		title: 'パスワード',
		width: 200,
		placeholder: '変更する場合は入力',
		newPlaceholder: '',
		maxLength: 20,
		defaultValue: '',
		validations: ["new_required", "password"]
	},
	{name: 'MailAddress', title: 'メールアドレス', width: 200, maxLength: 40, defaultValue: '', validations: ["mailAddress"]},
	{name: 'Kengen', title: '権限', width: 200, defaultValue: "2"},
	{name: 'ShowQR', title: 'QRコード', width: 200, filteringEnabled: false, sortingEnabled: false},
];

let selectableColumns = {
	Kengen: [{value: "1", name: "システム管理者"}, {value: "2", name: "事業者管理者"}, {value: "3", name: "一般ユーザ"}, {
		value: "4",
		name: "モバイル専用ユーザ"
	}]
};
let suggestionColumns = {
	JigyoushaCD_Obj: []
};
let clickableColumns = {
	ShowQR: {text: "表示", onClick: undefined}
}

class MasterUsers extends Component {

	constructor(props) {
		super(props);
		this.state = {
			rows: [],
			onEdit: false,
			isModify: false,
			dialogOpen: false,
			dialogOpenSave: false,
		}
		clickableColumns["ShowQR"]["onClick"] = this.handleClickQR;
	}

	/** override methods **/
	UNSAFE_componentWillMount() {
		const {dispatch} = this.props;
		this.getUserList();
		dispatch(getJigyoshaList());
		dispatch(resetMainListState());
		dispatch(resetConsigneeListStateNew());

	}

	componentDidMount() {
		const {dispatch, history} = this.props;
		dispatch(changeCurrentPath({currentPath: history.location.pathname}));
	}

	componentWillUnmount() {
		const {dispatch} = this.props;
		dispatch(resetMasterUsers());
	}

	/** event handlers **/
	handleClickSave = () => {
		const {auth, dispatch} = this.props;
		const {user} = auth;
		const jigyousha_cd = user.IsSystemAdmin ? null : user.JigyoushaCD;
		const {rows} = this.state;
		const addRow = _.filter(rows, {isAdd: true});
		const updateRow = _.filter(rows, (row) => {
			return row.isChange || row.isUpdateDelete
		});
		dispatch(setUserList({
			addRow,
			updateRow,
			jigyousha_cd,
			SessionID: auth.SessionID
		}));
	};

	handleClickClear = () => {
		const {onEdit, isModify} = this.state;
		if (onEdit || isModify) {
			this.setState({
				dialogOpen: true
			});
		} else {
			this.getUserList();
		}
	};

	doClear = () => {
		this.setState({
			dialogOpen: false
		});
		this.getUserList();

	};

	cancelClear = () => {
		this.setState({
			dialogOpen: false
		});
	};

	handleGetCurrentList = ({rows, addedRows, editRows}) => {
		const onEdit = (Object.keys(addedRows).length > 0) || (Object.keys(editRows).length > 0);
		const isModify = rows.some(row => {
			return row.isAdd || row.isChange || row.isUpdateDelete
		});
		this.setState({rows, onEdit, isModify});
	};

	handleClickDL = () => {
		const {auth, dispatch} = this.props;
		const {user} = auth;
		const jigyousha_cd = user.IsSystemAdmin ? null : user.JigyoushaCD;
		dispatch(fetchCsvMasterUser({jigyousha_cd}));
	};

	getUserList() {
		const {auth, dispatch} = this.props;
		const {user} = auth;
		const jigyousha_cd = user.IsSystemAdmin ? null : user.JigyoushaCD;
		dispatch(getUserList({jigyousha_cd}));
	}

	handleClickQR = (row) => {
		const {JigyoushaCD, JigyoushaName, UserID, UserName} = row;
		this.props.dispatch(getUserQrPdf({

			JigyoushaCD,
			JigyoushaName,
			UserID,
			UserName
		}));
	}
	afterCloseFunc = () => {
		const {dispatch} = this.props;
		dispatch(clearGetUserQrPdf());
	};


	render() {
		const {auth, settings, classes} = this.props;
		const {onEdit, isModify, dialogOpen} = this.state;


		const disabled = onEdit || !(isModify);
		const mainButtons = [
			{type: 'SAVE', func: this.handleClickSave, disabled},
			{type: 'CLEAR', func: this.handleClickClear},
			{type: 'DL', func: this.handleClickDL, hasMargin: true},
		];

		const rows = settings.data;
		suggestionColumns["JigyoushaCD_Obj"] = settings.jigyoshaData.map(suggestion => ({
			value: suggestion.JigyoushaCD,
			label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName,
		}));

		if (!auth.user.IsSystemAdmin) {
			columns[getArrayIndex(columns, "name", "JigyoushaCD_Obj")]["defaultValue"] = {
				value: auth.user.JigyoushaCD,
				label: auth.user.JigyoushaCD + ' : ' + auth.user.JigyoushaName,
			};
			selectableColumns["Kengen"][getArrayIndex(selectableColumns["Kengen"], "value", "1")]["disabled"] = true;
			columns[getArrayIndex(columns, "name", "Kengen")]["defaultValue"] = "3";
		} else {
			columns[getArrayIndex(columns, "name", "Kengen")]["defaultValue"] = "2";
			delete columns[getArrayIndex(columns, "name", "JigyoushaCD_Obj")]["defaultValue"];
			delete selectableColumns["Kengen"][getArrayIndex(selectableColumns["Kengen"], "value", "1")]["disabled"];
		}

		const printDialogOpen = (settings.pdfPath !== undefined);

		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>ユーザーマスタ</h2>
					</section>
					<p className={classes.cautionText}>
						※パスワードは暗号化され保存されています。パスワードがわからない、または変更する場合は、新しいパスワードをパスワードエリアに入力してください。
					</p>
					<section className="with_button">
						<div className={classNames(classes.buttonHide, classes.buttonHideLeft)}/>
						<div className={classNames(classes.buttonHide, classes.buttonHideRight)}/>
						<MasterTable
							dataSource={rows}
							columns={columns}
							selectableColumns={selectableColumns}
							suggestionColumns={suggestionColumns}
							clickableColumns={clickableColumns}
							defaultSorts={[{columnName: 'JigyoushaCD', direction: 'asc'}, {
								columnName: 'UserID',
								direction: 'asc'
							}]}
							getCurrentState={this.handleGetCurrentList}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				{printDialogOpen &&
				<PdfViewer
					filePath={settings.pdfPath}
					afterCloseFunc={this.afterCloseFunc}
				/>
				}
				<AlertDialog
					open={dialogOpen}
					title={"確認"}
					text={<span>編集中の内容は破棄されます</span>}
					okFunction={this.doClear}
					closeFunction={this.cancelClear}
				/>
				<ErrorDialog
					open={settings.isProcessError}
				/>
				<ReloadModal/>
				<LogoutModal/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation: state.navigation,
		auth: state.auth,
		settings: state.masterUsersSettings,

	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(MasterUsers);



// WEBPACK FOOTER //
// ./src/routes/master/users/index.js